/**
 * Simple event emitter for cross-component communication
 * Used to trigger data refreshes after payments/invoices are updated
 */

type EventCallback = (...args: any[]) => void;

class SimpleEventEmitter {
  private events: { [key: string]: EventCallback[] } = {};

  on(event: string, callback: EventCallback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event: string, callback: EventCallback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
  }

  emit(event: string, ...args: any[]) {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => callback(...args));
  }
}

export const eventEmitter = new SimpleEventEmitter();

// Event constants
export const EVENTS = {
  PAYMENT_RECORDED: 'payment_recorded',
  INVOICE_UPDATED: 'invoice_updated',
  REFRESH_INVOICES: 'refresh_invoices',
} as const;